// Simple tab title animation
(function() {
  console.log('Tab title animation script loaded');
  
  // Store the original title
  const originalTitle = document.title;
  console.log('Original title:', originalTitle);
  
  // Messages to display
  const messages = ["PlayFaire", "Wooden Toys, Built to Last", "Thoughtful Gifts, Beautifully Made", "Still Thinking About It...?", "We're Still here..", "Next-Day UK Delivery"];
  let currentIndex = 0;
  
  // Function to change the title
  function changeTitle() {
    const newTitle = messages[currentIndex] + ' | ' + originalTitle;
    document.title = newTitle;
    console.log('Title changed to:', newTitle);
    
    // Move to next message
    currentIndex = (currentIndex + 1) % messages.length;
  }
  
  // Start changing the title every 3 seconds
  console.log('Starting title animation');
  setInterval(changeTitle, 5000);
  
  // Initial change
  changeTitle();
})();
